import { WindDirection, SkiData, Distance } from "./types";
import { Loc } from "./location";
import { start } from "./constants";

// Raw skidata, see skidata.csv and the schema at gatsby-node.ts
export interface RawData {
  date: String;
  lat: number;
  lon: number;
  hours: number;
  temperature: number;
  wind: number;
  windDir: WindDirection;
  altitude: number;
}

// Raw data must be in date based order, ascending
export function calculate(raw: RawData[]) {
  let data = new Map<String, SkiData>();
  let prev = start;
  let sum = 0;

  for (const r of raw) {
    const loc = new Loc(r.lat, r.lon, r.altitude);
    const distance = new Distance(prev, loc, r.hours, sum);

    data.set(r.date, {
      loc: loc,
      distance,
      weather: { temp: r.temperature, wind: { speed: r.wind, dir: r.windDir } },
    });

    prev = loc;
    sum = distance.cumulative;
  }

  return data;
}
